<template>
  <el-dialog
    title="提示"
    :visible.sync="isShow"
    width="270px"
    custom-class="loginDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="dialog-body">
      <div class="d-header">
        <fm-button
          @click="handleClose"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <div class="d-content">
        <!-- <div class="title">{{ tips }}</div> -->
        <div class="loginBt" @click="handleLogin">
          <img
            class="feemooIcon"
            :src="$utils.getPng('icon-gfans-feemoo')"
            alt=""
          />
          <span class="title2">Feemoo快捷登录</span>
        </div>
      </div>
      <!-- <div class="d-content">
        <div class="title">{{ tips }}</div>
      </div> -->
      <!-- <div class="d-footer">
        <fm-button @click="handleLogin" type="primary" size="small"
          >立即登录/注册</fm-button
        >
      </div> -->
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import { eventBus } from '@/utils/event-bus'
export default {
  name: 'PromptTip',
  props: {
    tips: {
      type: String,
      default: '通过Feemoo授权登录/注册',
    },
  },
  data() {
    return {
      isShow: false,
      callback: null,
    }
  },
  mounted() {
    // 监听显示弹窗事件
    eventBus.$on('showLogin', ({ callback }) => {
      this.isShow = true
      this.callback = callback
    })
  },
  beforeDestroy() {
    eventBus.$off('showLogin')
  },
  methods: {
    //提交方法
    handleLogin: _.debounce(
      function () {
        this.isShow = false
        setTimeout(() => {
          let path = this.$route.path.toString().slice(1)
          const from = 'gfans'
          const fromUrl = this.$glb.jmdyhUrl + `/${path}`
          const encodedFrom = encodeURIComponent(from)
          const encodedFromUrl = encodeURIComponent(fromUrl)
          window.location.href =
            this.$glb.feemooUrl +
            `/login?from=${encodedFrom}&fromUrl=${encodedFromUrl}`
        }, 200)
        this.callback?.() // 执行回调
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    handleClose() {
      this.isShow = false
      // eventBus.$off('showLogin')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .loginDialog {
  width: 480px !important;
  .el-dialog__body {
    padding: 20px 24px 32px 24px;
  }
  .d-header {
    .left {
      display: flex;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }
  .d-content {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 56px 0 28px 0;
    .title {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      @include useTheme {
        color: getVar('text-color1-2c2c2c');
      }
    }
    .loginBt {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f67942;
      border-radius: 26px;
      width: 324px;
      height: 52px;
      cursor: pointer;
      &:hover {
        background: #ff9c71;
      }
      &:active {
        background: #d84f13;
      }
      .feemooIcon {
        width: 40px;
        height: 40px;
        object-fit: cover;
      }
      .title2 {
        font-weight: 600;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
      }
    }
  }
  .d-footer {
    justify-content: center;
    button {
      width: 164px;
      height: 36px;
      margin-left: 0 !important;
    }
  }
}
</style>
